import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid } from '@material-ui/core';
import TimeframeDropdown from 'src/components/TimeframeDropdown';
import IntegrationSummary from 'src/components/Integrations/IntegrationSummary';
import { selectCompany } from 'src/actions/company/companySelectors';

const useStyles = makeStyles(theme => ({
  root: {},
  dates: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  startDateButton: {
    marginRight: theme.spacing(1)
  },
  endDateButton: {
    marginLeft: theme.spacing(1)
  },
  calendarTodayIcon: {
    marginRight: theme.spacing(1)
  }
}));

const Header = ({ className, setPeriod, period, ...rest }) => {
  const classes = useStyles();
  const currentCompany = useSelector(selectCompany);

  const handlePeriodChange = ({ target: { value } }) => {
    setPeriod(value);
  };

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Grid alignItems="flex-end" container justify="space-between" spacing={3}>
        <Grid item>
          <Typography component="h1" gutterBottom variant="h1">
            Resumen
          </Typography>
        </Grid>
        {currentCompany?.integrationType && (
          <Grid item>
            <IntegrationSummary orientation="left" />
          </Grid>
        )}
        <Grid item>
          <TimeframeDropdown onChange={handlePeriodChange} period={period} />
        </Grid>
      </Grid>
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  setPeriod: PropTypes.func,
  period: PropTypes.string
};

export default Header;
